/** @jsx h */
import { h } from 'preact'
import FlagIcon from '../icons/FlagIcon'
import Placeholder from '../images/Placeholder'
import ProofPointStatus from '../ProofPointStatus'

const ClaimVerifier = ({ showStatus, verifier, status, claimStatus }) => {
  const { avatarUrl, location, name } = verifier

  const statusClass = status ? 'withStatus' : 'withoutStatus'
  const titleClass = status ? 'Heading' : 'Text-bodySerif'

  return (
    <div
      class={`Organization Organization--connection Organization--${statusClass}`}
    >
      <div>
        {avatarUrl &&
          <img
            class={`Avatar Avatar--xsmall Organization-avatar--${statusClass}`}
            src={avatarUrl}
            alt=''
          />}
        {!avatarUrl && <Placeholder />}
      </div>
      <div class='Organization-details'>
        <h3 class={titleClass}>{name}</h3>
        {location &&
          <p class='Organization-location'>
            <FlagIcon />
            &nbsp;{location.displayName}
          </p>}
        {showStatus && <ProofPointStatus status={claimStatus} />}
      </div>
    </div>
  )
}

export default ClaimVerifier
